import { MetadataEnum, DynamicFilterMetadataAssociation } from '@/enums';
import { find, forEach, keys, toUpper, snakeCase, cloneDeep, findIndex, filter } from 'lodash';

function addRequesterMetadataForPatient(metaData, patient, patients) {
    const requesterNameMeta = find(metaData, { metadata: MetadataEnum.REQUESTER_NAME });
    const requesterLinkMeta = find(metaData, { metadata: MetadataEnum.REQUESTER_LINK });

    if (requesterNameMeta && requesterLinkMeta) {
        if (patient.associationType === 'owner') {
            requesterNameMeta.status = 0;
            requesterLinkMeta.value = 0;
            requesterNameMeta.value = '';
        }
        else {
            requesterNameMeta.status = 1;
            requesterLinkMeta.value = 1;
            const owner = find(patients, { associationType: 'owner' });
            if (owner) {
                requesterNameMeta.value = owner.firstName + ' ' + owner.lastName;
            }
        }
        return [requesterNameMeta, requesterLinkMeta];
    }
    return [];
}

export function getSelectedPatientMetaValues(patient, metaData, patients, loggedUserCommunication, serviceHasDynamicFilter, dynamicServiceFilterMetadataValues, displayedMetadatas) {
    let metadataToUpdate = [];
    metaData = cloneDeep(metaData);
    const isProfileUserNewPatient = patient.uuid < 0;
    if (!isProfileUserNewPatient) {
        forEach(keys(patient), (key) => {
            if (MetadataEnum[toUpper(snakeCase(key))]) {
                const meta = find(metaData, { metadata: MetadataEnum[toUpper(snakeCase(key))] });
                if (meta) {
                    meta.value = patient[key];
                    metadataToUpdate.push(meta);
                }
            }
        });
    }
    else {
        const requesterEmailMeta = find(metaData, { metadata: MetadataEnum.EMAIL });
        const requesterCellPhoneMeta = find(metaData, { metadata: MetadataEnum.CELLPHONE });
        const requesterPhoneMeta = find(metaData, { metadata: MetadataEnum.PHONE });
        if (loggedUserCommunication && loggedUserCommunication.email && requesterEmailMeta) {
            requesterEmailMeta.value = loggedUserCommunication.email;
            metadataToUpdate.push(requesterEmailMeta);
        }
        if (loggedUserCommunication && loggedUserCommunication.cellphone && requesterCellPhoneMeta) {
            requesterCellPhoneMeta.value = loggedUserCommunication.cellphone;
            metadataToUpdate.push(requesterCellPhoneMeta);
        }
        if (loggedUserCommunication && loggedUserCommunication.phone && requesterPhoneMeta) {
            requesterPhoneMeta.value = loggedUserCommunication.phone;
            metadataToUpdate.push(requesterPhoneMeta);
        }

        // if service has dynamic filter metadata, set the value coming from dynamicServiceFilterMetadataValues
        if (serviceHasDynamicFilter) {
            forEach(DynamicFilterMetadataAssociation, (dynamicFilterMeta) => {
                const index = findIndex(dynamicServiceFilterMetadataValues, ['associatedMetadataId', dynamicFilterMeta]);
                const foundMetaData = find(metaData, { metadata: dynamicFilterMeta });
                if (foundMetaData) {
                    if (index !== -1) {
                        foundMetaData.value = dynamicServiceFilterMetadataValues[index].value;
                    }
                    metadataToUpdate.push(foundMetaData);
                }
            });
        }
    }

    const requesterMetas = addRequesterMetadataForPatient(metaData, patient, patients, metadataToUpdate);

    metadataToUpdate = filter(metadataToUpdate, m => find(displayedMetadatas, meta => meta.metadata === m.metadata));

    return [...metadataToUpdate, ...requesterMetas];
}
